

















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import Loading from '@/components/Loading.vue'
import LaunchPadWidget from '@/pages/onboarding/_onboarding/LaunchPadWidget.vue'
import TestMode from '@/pages/onboarding/_onboarding/TestMode.vue'
import CompleteSurveyPrompt from '@/pages/onboarding/_onboarding/CompleteSurveyPrompt.vue'
import { setLaunchPadWidgetLive } from '@/api/onboarding'
import { notifySuccess } from '@/utils/notices'
import { SurveyWhole } from '@/pages/simple-survey/entities/survey'
import {
    getRecommendedNextSteps,
    getLaunchPadWidgetData
} from '@/api/onboarding'
import { LaunchPadInitialData } from '@/pages/appstore/entities/appstore'
import { tabTypes } from '@/pages/appstore/entities/subMenu'
import EngagementBanner from '@/mobile/src/components/engagement/EngagementBanner.vue'

declare let ENABLE_LAUNCH_PAD
declare let ENABLE_TEST_MODE
declare let HAS_RECOMMENDED_NEXT_STEPS

@Component<OnboardingApp>({
    components: {
        EngagementBanner,
        Loading,
        LaunchPadWidget,
        TestMode,
        CompleteSurveyPrompt
    }
})
export default class OnboardingApp extends Vue {
    public recommendedAppsTabs: string[] = [tabTypes.discover, tabTypes.installed]
    public launchPadInitialData: LaunchPadInitialData | null = null
    public launchPadVisibleToUser = true
    public unallowedPaths: string[] = [
        '/upload/selectfile',
        '/upload/match',
        '/upload/checkmatch'
    ]
    public draftSurvey: SurveyWhole | null = null

    @Prop({ type: Boolean, required: false, default: false })
    public readonly inAppstore!: boolean
    @Prop({ type: String, required: false, default: '' })
    public readonly appstoreTab!: string

    @Getter public getInstalledAppsNames
    @Getter public isShowLaunchPad
    @Getter public isShowTestMode

    @Action public setShowLaunchPad
    @Action public setShowTestMode

    public get getHiddenInCurrentPath() {
        return this.unallowedPaths.includes(window.location.pathname)
    }

    public get isInSurveyBuilder() {
        return window.location.pathname.split('/').includes('survey')
    }

    public get showCompleteSurveyPrompt() {
        return (
            this.draftSurvey?.status !== 'none' &&
            !this.isInSurveyBuilder &&
            this.draftSurvey
        )
    }

    public async setLaunchPadWidgetData() {
        if (ENABLE_LAUNCH_PAD) {
            const { data } = await getLaunchPadWidgetData()
            this.launchPadVisibleToUser = data['visibleToCurrentUserOutAppStore']
            if (data['launchPadAppsNames'].length !== 0) {
                this.launchPadInitialData = data
                this.setShowLaunchPad(ENABLE_LAUNCH_PAD)
            } else {
                // show test mode if Launchpad is set done in back end
                this.launchPadVisibleToUser = true
                this.setTestModeData()
            }
        }
    }

    @Watch('isShowLaunchPad')
    public setTestModeData() {
        this.setShowTestMode(ENABLE_TEST_MODE)
    }

    public async setCompleteSurveyPrompt() {
        if (HAS_RECOMMENDED_NEXT_STEPS) {
            const { data } = await getRecommendedNextSteps()
            this.draftSurvey = data.draftSurvey
        }
    }

    @Watch('getInstalledAppsNames')
    public async watchGetInstalledAppsNames() {
        if (this.isShowLaunchPad && this.getInstalledAppsNames.length > 0) {
            this.setShowLaunchPad(false)
            // to turn off the enable_launch_pad toggle
            await setLaunchPadWidgetLive()
            this.launchPadVisibleToUser = true
            notifySuccess('Your primary integration is installed!', {
                pos: 'top-right',
                timeout: 5000
            })
        }
    }

    public async mounted() {
        if (
            typeof ENABLE_LAUNCH_PAD === 'undefined' ||
            typeof ENABLE_TEST_MODE === 'undefined'
        ) {
            return
        }
        // Onboarding flow 1st step
        await this.setLaunchPadWidgetData()
        // Onboarding flow 2nd step
        this.setTestModeData()
        // Onboarding flow 3rd step
        await this.setCompleteSurveyPrompt()
        await this.watchGetInstalledAppsNames()
    }
}
